import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import SupplierWithItemReportModal from "../components/supplierWithItemReportModal";
import Time from "../components/time";
import { useNavigate, Link } from "react-router-dom";

const DeliveryRating = () => {
     useAuthRedirect();
    const [showModal, setShowModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const branch = localStorage.getItem("branch");
    const user = localStorage.getItem("username");
    const [sCode, setScode] = useState(null);
    const [sName, setSName] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSelectItem = async (supplier) => {
        try {
            setScode(supplier.supplierMaster_code);
            setSName(supplier.supplierMaster_name);

            const response = await axios.get("https://rfs2.infraconsoft.net.in/api/vendorRating_delivery", {
                params: { sCode: supplier.supplierMaster_code, branch },
            });

            if (response.data.purchaseOrderList.length > 0) {
                setSelectedItems(response.data.purchaseOrderList);
            } else {
                setSelectedItems([]);
            }

        } catch (error) {
            console.error("Error fetching supplier items:", error);
        }
    };

    useEffect(() => {
        if (sCode && branch) {
            fetchData();
        }
    }, [sCode, branch]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vendorRating_delivery1`, {
                params: { sCode, branch },
            });

            setData(response.data.purchaseOrderList1 || []);
        } catch (error) {
            console.error("Error fetching itemList:", error);
        } finally {
            setLoading(false);
        }
    };

    // Helper: Render star rating based on score
    const renderStars = (score) => {
        const fullStars = Math.floor(score / 20); // out of 100 → 5 stars
        const stars = "★".repeat(fullStars) + "☆".repeat(5 - fullStars);
        return <span style={{ color: "#FFD700", fontSize: "1.2em" }}>{stars}</span>;
    };

    // Helper: Return badge color based on score
    const getRatingBadge = (score) => {
        if (score >= 80) return "green";
        if (score >= 50) return "orange";
        return "red";
    };

    return (
        <div id="admin-container">
            <InventoryNav />
            <div className="content-right">
                <section>
                    <div className="back-div">
                        <h2 className="add-txt">Supplier Rating - GRN</h2>
                        <Link to="/inventory/vendorControlRatingMenu">
                            <p className="back-button"><i className="fa-solid fa-backward"></i> Back</p>
                        </Link>
                    </div>
                    <Time />
                </section>

                <div className="form-container">
                    <form className="vehicle-form">
                        <div className="form-row">
                            <div className="form-group">
                                <label>Supplier Code :</label>
                                <input type="text" value={sCode || ""} readOnly placeholder="Select Supplier" />
                            </div>
                            <div className="form-group">
                                <label>Supplier Name :</label>
                                <input type="text" value={sName || ""} readOnly />
                            </div>
                        </div>

                        <div className="flex_buttons">
                            <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                                Select Supplier
                            </button>
                        </div>

                        {/* Summary Table */}
                        <div className="content-table">
                            <h3>Rating Summary</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Supplier Code</th>
                                        <th>Supplier Name</th>
                                        <th>DR%</th>
                                        <th>QR%</th>
                                        <th>SR%</th>
                                        <th>Stars</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedItems.length > 0 ? (
                                        selectedItems.map((item, index) => {
                                            const mD = item.total_ordered_quantity ?? 0;
                                            const mP = item.total_packed_quantity ?? 0;

                                            const poDate = item.first_po_date ? new Date(item.first_po_date) : null;
                                            const grnDate = item.first_grn_date ? new Date(item.first_grn_date) : null;
                                            const daysDiff = poDate && grnDate ? (grnDate - poDate) / (1000 * 60 * 60 * 24) : 0;

                                            let d1 = 0, d2 = 0;
                                            if (poDate && grnDate && poDate >= grnDate) d1 = mP;
                                            if (daysDiff > 0 && daysDiff <= 7) d2 = mP;

                                            const dr = mD > 0 ? ((d1 + 0.5 * d2) / mD) * 100 : 0;
                                            const qr = mP > 0 ? (mD / mP) * 100 : 0;
                                            const sr = 0.4 * dr + 0.6 * qr;

                                            const badgeColor = getRatingBadge(sr);

                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.grnheader_suppliercode}</td>
                                                    <td>{item.suppliermaster_name}</td>
                                                    <td>{dr.toFixed(2)}%</td>
                                                    <td>{qr.toFixed(2)}%</td>
                                                    <td>
                                                        <span style={{
                                                            backgroundColor: badgeColor,
                                                            color: "white",
                                                            padding: "4px 8px",
                                                            borderRadius: "6px"
                                                        }}>
                                                            {sr.toFixed(2)}%
                                                        </span>
                                                    </td>
                                                    <td>{renderStars(sr)}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr><td colSpan="7">No Items</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Detailed Breakdown Table */}
                        <div className="content-table">
                            <h3>Rating Details</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>GRN No</th>
                                        <th>Date</th>
                                        <th>PO No.</th>
                                        <th>Schd Date</th>
                                        <th>D1</th>
                                        <th>D2</th>
                                        <th>DR%</th>
                                        <th>Packed Qty</th>
                                        <th>Accepted Qty</th>
                                        <th>QR%</th>
                                        <th>SR%</th>
                                        <th>Stars</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length > 0 ? (
                                        data.map((item, index) => {
                                            const date1 = new Date(item.purchaseOrderSchedule_date);
                                            const dateGRN = new Date(item.grnheader_date);
                                            const daysDiff = (dateGRN - date1) / (1000 * 60 * 60 * 24);

                                            const mD = item.purchaseOrderSchedule_quantity ?? 0;
                                            const mPQ = item.grnSchedule_PackedQuantity ?? 0;
                                            const mAQ = item.grnDetail_acceptedQuantity ?? 0;

                                            let d1 = 0, d2 = 0;
                                            if (date1 >= dateGRN) d1 = mPQ;
                                            if (daysDiff > 0 && daysDiff <= 7) d2 = mPQ;

                                            const dr = mD > 0 ? ((d1 + 0.5 * d2) / mD) * 100 : 0;
                                            const qr = mPQ > 0 ? (mAQ / mPQ) * 100 : 0;
                                            const sr = 0.4 * dr + 0.6 * qr;

                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.grnheader_number}</td>
                                                    <td>{dateGRN.toLocaleDateString()}</td>
                                                    <td>{item.purchaseOrderSchedule_poNumber}</td>
                                                    <td>{date1.toLocaleDateString()}</td>
                                                    <td>{d1}</td>
                                                    <td>{d2}</td>
                                                    <td>{dr.toFixed(2)}%</td>
                                                    <td>{mPQ}</td>
                                                    <td>{mAQ}</td>
                                                    <td>{qr.toFixed(2)}%</td>
                                                    <td>{sr.toFixed(2)}%</td>
                                                    <td>{renderStars(sr)}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr><td colSpan="13">No Items</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </form>
                </div>
            </div>

            <SupplierWithItemReportModal
                showModal={showModal}
                closeModal={() => setShowModal(false)}
                branch={branch}
                onSelectItem={handleSelectItem}
            />
        </div>
    );
};

export default DeliveryRating;
